// extracted by mini-css-extract-plugin
export default {"container":"ovmPbZwy","row_first":"h3xuFAA2","row_second":"p2bHPZHA","rightCorner":"CfqO4vGc","user":"_gWpjn6b","logo":"VSbe77PT","line":"Be7VnooE"};